import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  CreditCard,
  Printer,
  Save,
  CheckCircle,
  Smartphone,
  Building2,
  Wallet,
  ArrowLeft,
} from "lucide-react";

const styles = {
  container: {
    background: "#f9fafb",
    minHeight: "100vh",
    padding: "16px",
    fontFamily: "'Inter', sans-serif",
  },
  billingWrapper: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 8px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 10px -5px rgba(0, 0, 0, 0.04)",
    overflow: "hidden",
    margin: "0 auto",
  },
  
  header: {
    background: "linear-gradient(135deg, #047857 0%, #059669 100%)",
    color: "white",
    padding: "20px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  
  headerTitle: {
    fontSize: "24px",
    fontWeight: "700",
    margin: "0",
    letterSpacing: "-0.3px",
  },
  
  headerSubtitle: {
    fontSize: "14px",
    fontWeight: "400",
    opacity: "0.9",
    margin: "2px 0 0 0",
  },
  
  sectionCard: {
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    padding: "16px",
    marginBottom: "14px",
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "4px",
    display: "block",
  },
  input: {
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    width: "100%",
    outline: "none",
  },
  paymentGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "10px",
  },
  paymentBox: {
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    padding: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    background: "#f9fafb",
  },
  paymentBoxActive: {
    background: "#e0f2fe",
    color: "#0369a1",
    borderColor: "#bae6fd",
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 0",
    fontSize: "14px",
  },
  summaryTotal: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    fontWeight: "700",
    color: "#047857",
    borderTop: "1px solid #e5e7eb",
    marginTop: "6px",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "12px",
  },
  buttonPrimary: {
    background: "#059669",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
  },
  buttonSecondary: {
    background: "#fff",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    color: "#374151",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
  },
};

const AddPaymentForm = () => {
  const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState("cash");
  const [cartItems] = useState([]);
  const paymentMethods = [
    { id: "cash", label: "Cash", icon: <Wallet size={16} /> },
    { id: "card", label: "Card", icon: <CreditCard size={16} /> },
    { id: "upi", label: "UPI", icon: <Smartphone size={16} /> },
    { id: "insurance", label: "Insurance", icon: <Building2 size={16} /> },
  ];

  const billingFormik = useFormik({
    initialValues: { discount: 0, insuranceCoverage: 0, taxRate: 18 },
    validationSchema: Yup.object({
      discount: Yup.number().min(0).max(100),
      insuranceCoverage: Yup.number().min(0).max(100),
    }),
    onSubmit: (values) => {
      alert("Bill generated successfully!");
      console.log(values);
    },
  });

  const totals = {
    grossAmount: 0,
    discountAmount: 0,
    insuranceAmount: 0,
    taxAmount: 0,
    netAmount: 0,
  };

  return (
    <div style={styles.container}>
      {/* Header */}
        <div style={styles.topHeader}>
              <div className="flex items-center gap-4">
                <button
                  onClick={() => navigate("/PharmacyBilling")}
                  className="p-3 m-3 bg-gray-100 hover:bg-gray-200 rounded-xl transition-all duration-300 group"
                >
                  <ArrowLeft className="w-5 h-5 text-gray-600 group-hover:text-gray-800" />
                </button>
                <div>
                  <h1 className="text-3xl font-bold text-gray-900">
                 Billing  Summary
                  </h1>
                  <p className="text-gray-600 mt-1">
                    
                  </p>
                </div>
              </div>
            </div>
     <div style={styles.billingWrapper}>
        {/* Header */}
        <div style={styles.header}>
          <div>
            <h1 style={styles.headerTitle}> Billing Summary</h1>
            <p style={styles.headerSubtitle}>  A quick overview of your sales and billing information</p>
          </div>
         
        </div>

      {/* Adjustments */}
      <div style={styles.sectionCard}>
        <h3 className="text-[15px] font-semibold mb-3">Adjustments</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label style={styles.label}>Discount (%)</label>
            <input
              style={styles.input}
              type="number"
              name="discount"
              value={billingFormik.values.discount}
              onChange={billingFormik.handleChange}
            />
          </div>
          <div>
            <label style={styles.label}>Insurance Coverage (%)</label>
            <input
              style={styles.input}
              type="number"
              name="insuranceCoverage"
              value={billingFormik.values.insuranceCoverage}
              onChange={billingFormik.handleChange}
            />
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div style={styles.sectionCard}>
        <h3 className="text-[15px] font-semibold mb-3">Payment Method</h3>
        <div style={styles.paymentGrid}>
          {paymentMethods.map((method) => (
            <div
              key={method.id}
              style={{
                ...styles.paymentBox,
                ...(selectedPayment === method.id
                  ? styles.paymentBoxActive
                  : {}),
              }}
              onClick={() => setSelectedPayment(method.id)}
            >
              {method.icon}
              <span>{method.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Summary */}
      <div style={styles.sectionCard}>
        <div style={styles.summaryRow}>
          <span>Gross Amount:</span>
          <span>₹{totals.grossAmount.toFixed(2)}</span>
        </div>
        <div style={styles.summaryRow}>
          <span>Tax (GST 18%):</span>
          <span>₹{totals.taxAmount.toFixed(2)}</span>
        </div>
        <div style={styles.summaryTotal}>
          <span>Net Payable:</span>
          <span>₹{totals.netAmount.toFixed(2)}</span>
        </div>
      </div>

      {/* Buttons */}
      <div style={styles.actionButtons}>
        <button style={styles.buttonSecondary}>
          <Save size={14} /> Save Draft
        </button>
        <button
          style={styles.buttonPrimary}
          onClick={billingFormik.handleSubmit}
        >
          <CheckCircle size={14} /> Generate Bill
        </button>
        <button style={styles.buttonSecondary}>
          <Printer size={14} /> Print
        </button>
        <button type="button" 
        style={styles.buttonSecondary}
         onClick={() => console.log("Share Bill")} > 
         Share 
         </button>
      </div>
    </div>
    </div>
  );
}

export default AddPaymentForm;
